export { default } from './PagerViewAdapter';
